import React from 'react';
import './index.scss';

const Score = (props)=> {
	let color;
	if(props.role === "adult"){
		color = "orange";
	}else{
		color = "teal";
	}
	console.log(props.role);
	if(props.Results){
		if(props.Score <= 12){
			color = "orange";
		}else if(props.Score > 12 && props.Score < 20){
			color = "yellow";
		}else if(props.Score >= 20){
			color = "teal";
		}else{
			color = "orange";
		}
	}
  return (
	<div className="score">
		<h2 className="scoreText header">Score</h2>
		<svg width="188" height="188" viewBox="0 0 188 188">
			<circle cx="94" cy="94" r="94" className={`fill ${color}`} />
			<circle cx="94" cy="94" r="72" className={`fill ${color}`} />
			<circle cx="94" cy="94" r="56" className="white" />
			<circle cx="94" cy="94" r="56" className={`dotted ${color}`} />
			<text className={`number header1 ${color}`} x="95" y="115" textAnchor="middle">{props.Score}</text>
		</svg>
	</div>
  );
}

export default Score;
